var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-list-item",
        { staticClass: "d-flex pa-4 border-bottom side-cart-top" },
        [
          _c("i", {
            staticClass: "la la-shopping-cart la-3x me-2 text-primary",
          }),
          _vm._v(" "),
          _c("div", { staticClass: "lh-1-4" }, [
            _c("div", { staticClass: "fs-16 fw-500" }, [
              _vm._v(_vm._s(_vm.getCartCount) + " " + _vm._s(_vm.$t("items"))),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fs-12 opacity-60" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$store.getters["app/appName"]) +
                  "\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "ms-auto",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.updateCartDrawer(false)
                },
              },
            },
            [_c("i", { staticClass: "la la-close fs-20" })]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.getCartProducts.length > 0
        ? _c(
            "div",
            { staticClass: "px-5 py-2 overflower side-cart-content" },
            [
              _vm.getShopMinOrder() > 0
                ? _c("min-order-progress", {
                    staticClass: "mt-3",
                    attrs: {
                      "cart-price": _vm.getCartPrice,
                      "min-order": _vm.getShopMinOrder(),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-list",
                { attrs: { dense: "" } },
                [
                  _c("cart-items", {
                    attrs: {
                      "cart-items": _vm.getCartProducts,
                      "cart-mode": _vm.cartMode,
                      "cart-type": _vm.cartType,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c("div", { staticClass: "px-5 py-2 side-cart-content" }, [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column justify-center h-100 text-center pa-5",
              },
              [
                _c("div", { staticClass: "text-center" }, [
                  _c("img", {
                    staticClass: "pa-10",
                    attrs: {
                      src: _vm.static_asset(
                        `/assets/img/img_shopping_basket.gif`
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "fs-20" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t("your_shopping_bag_is_empty_start_shopping")
                      ) +
                      "\n            "
                  ),
                ]),
              ]
            ),
          ]),
      _vm._v(" "),
      _c(
        "v-list-item",
        { staticClass: "pa-4 border-top side-cart-bottom d-block" },
        [
          false ? _c("coupon-form", { staticClass: "mb-3" }) : _vm._e(),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { elevation: "0", color: "primary", large: "", block: "" },
              on: { click: _vm.checkout },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("checkout")) + "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }